import type { GameWorld } from '../world'
import { T } from '../tunables'

export function wanderSystem(world: GameWorld, dt: number, elapsed: number): void {
  for (const e of world.with('wander', 'velocity')) {
    if (e.player || e.absorbing || e.ally) continue

    // Continuous low-amplitude Perlin-ish drift using per-entity seed
    const s = e.wander.noiseSeed
    e.velocity.x += Math.sin(elapsed * 1.3 + s) * T.wander.driftAmp * dt
    e.velocity.y += Math.cos(elapsed * 1.1 + s * 1.7) * T.wander.driftAmp * dt

    // Damping so velocity doesn't compound
    e.velocity.x -= e.velocity.x * T.wander.damping * dt
    e.velocity.y -= e.velocity.y * T.wander.damping * dt

    // Impulse burst timer
    e.wander.impulseTimer -= dt
    if (e.wander.impulseTimer <= 0) {
      const angle = Math.random() * Math.PI * 2
      e.velocity.x = Math.cos(angle) * T.wander.burstSpeed
      e.velocity.y = Math.sin(angle) * T.wander.burstSpeed
      e.wander.impulseTimer = T.wander.burstIntervalMin + Math.random() * T.wander.burstIntervalRange
    }
  }
}
